module Sm.UI.Autotimer

open MobF

open Sm.UI.Form.Control
open Sm.UI.InputParser
open Sm.UI.Timer
open Sm.UI.Pad

type State = {
    Empty: unit
}

type Msg =
    | RunOne
    | RunTwo
    | RunThree
    | RunFour

type Computed =
    abstract RunOne: Button<Msg>
    abstract RunTwo: Button<Msg>
    abstract RunThree: Button<Msg>
    abstract RunFour: Button<Msg>

type Autotimer = Model<State, Msg, Computed>

let create (timer: TimerModel) (pad: Pad): Autotimer =
    let addStep text duration =
        $"%s{text} ..%i{duration}" 
        |> InputEditor.accept (Add >> pad.Post)


    let advanceTimer () =
        match timer.Computed.Mode, timer.Computed.Time with
        | Running, Some (Under _) -> ()
        | _ -> timer.Post(timer.Computed.RightButton.Command)

    let runSimple duration =
        let text =
            if timer.Computed.Steps.IsEmpty then "Timer"
            else "More"

        addStep text duration
        advanceTimer ()

    let runComplex steps =
        for text, duration in steps do
            addStep text duration
        advanceTimer ()

    let init () =
        { Empty = () }

    let update state = function
        | RunOne ->
            runSimple 6
            state

        | RunTwo ->
            runSimple 12
            state

        | RunThree ->
            runSimple 25
            state

        | RunFour ->
            runComplex [
                "First Session", 25
                "Break", 5
                "Second Session", 25
                "Break", 5
            ]
            state

    let compute _ =
        { new Computed with
            member _.RunOne =
                {
                    Content = Label "6m"
                    Command = RunOne
                    State = ButtonState.Default
                }

            member _.RunTwo =
                {
                    Content = Label "12m"
                    Command = RunTwo
                    State = ButtonState.Default
                }

            member _.RunThree =
                {
                    Content = Label "25m"
                    Command = RunThree
                    State = ButtonState.Default
                }

            member _.RunFour =
                {
                    Content = Label "HOUR"
                    Command = RunFour
                    State = ButtonState.Default
                }
                            
        }

    Model.useInit init
    |> Model.andUpdate update
    |> Model.createWithComputed compute
